import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import DashboardTexts from "../../constants/dashboard";
import authIcon from "../../assets/images/svg/auth_menu_icon.svg";
import linesIcon from "../../assets/images/svg/lines_menu_icon.svg";
import searchIcon from "../../assets/images/svg/search_menu_icon.svg";
import servicesIcon from "../../assets/images/svg/services_menu_icon.svg";
import userInfoIcon from "../../assets/images/svg/user_info_menu_icon.svg";
import promotionsIcon from "../../assets/images/svg/promotions_menu_icon.svg";
import transactionsIcon from "../../assets/images/svg/transactions_menu_icon.svg";
import outputIcon from "../../assets/images/svg/outputIcon.svg";
import accountingIcon from "../../assets/images/svg/accountingIcon.svg";
import settingIcon from "../../assets/images/svg/setting.svg";
import invoice from "../../assets/images/svg/invoice.svg"
import backIcon from "../../assets/images/svg/back.svg"
import email from "../../assets/images/svg/email_icon.svg"
import userIcon from "../../assets/images/svg/user.svg"
import calendar from "../../assets/images/svg/calendar.svg"
import trolley from "../../assets/images/svg/trolley.svg"
import listIcon from "../../assets/images/svg/listIcon.svg"

import { useLocation } from 'react-router-dom';
function Dashboard(props) {
  const location = useLocation();
  const [activeMiniMenu, setActiveMiniMenu] = useState(0);
  const navigate = useNavigate();
  const menu2 = [
    {
      text: DashboardTexts.search,
      link: "/",
      src: searchIcon,
    },
    {
      text: DashboardTexts.activateLines,
      link: "/lines-list",
      src: linesIcon,
    },
    {
      text: DashboardTexts.promotions,
      link: "/promotions",
      src: promotionsIcon,
    },
    {
      text: DashboardTexts.setting,
      link: "/changeEmailList",
      src: settingIcon,
    },
    {
      text: DashboardTexts.accounting,
      link: "/invoicelList",
      src: accountingIcon,
    },
    {
      text: DashboardTexts.activities,
      link: "/activities",
      src: userIcon,
    },

  ]
  const menuSetting = [
    {
      text: DashboardTexts.back,
      link: "/",
      src: backIcon,
    },
    {
      text: DashboardTexts.changeEmail,
      link: "/changeEmailList",
      src: email,
    },
    {
      text: DashboardTexts.calendarSettings,
      link: "/calendar",
      src: calendar,
    },
    {
      text: DashboardTexts.activePackage,
      link: "/activePackage",
      src: trolley,
    },
    {
      text: DashboardTexts.restrictedCall,
      link: "/restrictedCall",
      src: listIcon,
    }
  ]

  const menuAccounting = [
    {
      text: DashboardTexts.back,
      link: "/",
      src: backIcon,
    },
    {
      text: DashboardTexts.invoice,
      link: "/invoicelList",
      src: invoice,
    },
    {
      text: DashboardTexts.outPut,
      link: "/output",
      src: outputIcon,
    },
  ]


  const menus = [
    {
      text: DashboardTexts.back,
      link: "/",
      src: backIcon,
    },

    {
      text: DashboardTexts.userInfo,
      link: "/user-info",
      src: userInfoIcon,
    },
    {
      text: DashboardTexts.services,
      link: "/services",
      src: servicesIcon,
    },
    {
      text: DashboardTexts.lines,
      link: "/lines",
      src: linesIcon,
    },
    {
      text: DashboardTexts.transactions,
      link: "/transaction",
      src: transactionsIcon,
    },
    {
      text: DashboardTexts.userAuth,
      link: "/authentication",
      src: authIcon,
    },

  ];

  useEffect(() => {
    if (props.type === 6) {
      localStorage.setItem('type', 'actvetedMenu');
    }
    if (props.type === 1 || props.type === 8 || props.type === 10 || props.type === 11) {
      localStorage.setItem('type', 'none');
    }
  }, [props.type])



  const goTo = (link) => {
    let fromChangeEmail = localStorage.getItem('UserIdFromChangeEmail')
    let from = localStorage.getItem("type")
    if (link === "/" && from === 'actvetedMenu') {
      if (props.type === 5) {
        var parts = location.pathname.split("/");
        parts.pop(); // Remove last array object       
        navigate(`${parts}/lines-list`);

      }
    }
    else if (link === "/" && fromChangeEmail) {
      navigate('/changeEmailList');
      localStorage.removeItem('UserIdFromChangeEmail')
    }
    else {
      navigate(link)
    }
  }

  return (
    props.login &&
      props.type === 9 ? (
      <ul className="dashboard" >
        <li
          onClick={() => {
            navigate('/promotions');
          }}
          className={
            location.pathname === '/'
              ? "active-menu"
              : "inactive-menu"
          }
        >
          <img src={backIcon} alt={DashboardTexts.back} />
          <br />
          <span className='span-link'>{DashboardTexts.back}</span>
        </li>
      </ul>

    ) :
      props.type === 5 || props.type === 2 || props.type === 3 || props.type === 4 || props.type === 7 ? (
        <ul className="dashboard">
          {menus.map((m, i) => (
            <li
              key={i}
              onClick={() => {
                goTo(m.link)
                // history.push(m.link)
              }}
              className={
                location.pathname === m.link
                  ? "active-menu"
                  : "inactive-menu"
              }
            >
              <img src={m.src} alt={m.text} />
              <br />
              <span className='span-link' >{m.text}</span>
            </li>

          ))}
        </ul>
      ) : props.type === 10 || props.type === 11 || props.type === 17 || props.type === 18 || props.type === 19 ? (
        <ul className="dashboard">
          {menuSetting.map((m, i) => (
            < li
              key={i}
              onClick={() => {
                goTo(m.link)
                // history.push(m.link)
              }}
              className={
                (location.pathname === "/setting" && m.link === '/changeEmailList') || (location.pathname === m.link)
                  ? "active-menu"
                  : "inactive-menu"
              }
            >
              <img src={m.src} alt={m.text} />
              <br />
              <span className='span-link' >{m.text}</span>
            </li>))
          }
        </ul >)
        :
        props.type === 12 || props.type === 14 ? (
          <ul className="dashboard">
            {menuAccounting.map((m, i) => (

              < li
                key={i}
                onClick={() => {
                  goTo(m.link)
                }}
                className={
                  (location.pathname === "/invoicelList" && m.link === '/invoicelList') || (location.pathname === m.link)
                    ? "active-menu"
                    : "inactive-menu"
                }
              >
                <img src={m.src} alt={m.text} />
                <br />
                <span className='span-link' >{m.text}</span>
              </li>))
            }
          </ul >)
          :
          // props.type === 8 ? (
          //   <ul className="dashboard">
          //     <li  onClick={() => goTo('/promotions')} className="inactive-menu">
          //     <span className='span-link' >{DashboardTexts.back}</span>
          //     </li>
          //   </ul>
          // ) :
          props.login ?
            <ul className="dashboard">

              {menu2.map((m, i) => (
                <li
                  key={i}
                  onClick={() => {
                    navigate(m.link)
                  }}
                  className={
                    location.pathname === m.link
                      ? "active-menu"
                      : "inactive-menu"
                  }
                >
                  <img src={m.src} alt={m.text} />
                  <br />
                  <span className='span-link'>{m.text}</span>
                </li>

              ))}
            </ul> : ''


  )
}







//   props.login && (
//     <>
//       {props.search ? (
//         <ul className="dashboard">
//           {menus.map((m, i) => (
//             <li
//               key={i}
//               onClick={() => {
//                 history.push(m.link);
//               }}
//               className={
//                 window.location.pathname === m.link
//                   ? "active-menu"
//                   : "inactive-menu"
//               }
//             >
//               <img src={m.src} alt={m.text} />
//               <Link to={m.link}>{m.text}</Link>
//             </li>
//           ))}
//         </ul>
//       ) : (
//         <ul className="dashboard">
//           <li
//             onClick={() => {
//               history.push(menus[0].link);
//               setActiveMiniMenu(0);
//             }}
//             className={activeMiniMenu === 0 ? "active-menu" : "inactive-menu"}
//           >
//             <img src={menus[0].src} alt={menus[0].text} />
//             <Link to={menus[0].link}>{menus[0].text}</Link>
//           </li>
//           <li
//             onClick={() => {
//               history.push(menus[1].link);
//               setActiveMiniMenu(1);
//             }}
//             className={activeMiniMenu === 1 ? "active-menu" : "inactive-menu"}
//           >
//             <img src={menus[1].src} alt={menus[1].text} />
//             <Link to={menus[1].link}>{menus[1].text}</Link>
//           </li>
//           <li
//             onClick={() => {
//               history.push(menus[2].link);
//               setActiveMiniMenu(2);
//             }}
//             className={activeMiniMenu === 2 ? "active-menu" : "inactive-menu"}
//           >
//             <img src={menus[2].src} alt={menus[2].text} />
//             <Link to={menus[2].link}>{menus[2].text}</Link>
//           </li>
//         </ul>
//       )}
//     </>
//   )

export default Dashboard;
